import { useCallback } from 'react'
import { defaultStmCartValues, useStmCartStoreBase } from './use-stm-cart-store'

/**
 * 重置所有品牌的購物車狀態
 */
export const useStmResetAllCarts = () => {
  const resetAllCarts = useCallback(() => {
    const state = useStmCartStoreBase.getState()
    useStmCartStoreBase.setState(
      Object.fromEntries(Object.keys(state).map(id => [id, { ...defaultStmCartValues }])),
    )
  }, [])

  return { resetAllCarts }
}
